import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { IAppState } from "../../types/stores/index";
//import { useSaasHeader } from "@ascend/ui-core/hooks";

const SaasHeader: React.FC = () => {
    const SAAS_ASSETS_URL = "https://da-saas-blade-dev-saas-assets-ui.hb-e1-dev.experianone.io";
    const enabledFeatures = useSelector((state: IAppState) => state.session.enabledFeatures || []);
    const wayfarerMode = enabledFeatures.includes("integrate-wayfarer-header");
    const title = "Audience Engine";
    const HEADER_ELEMENT_KEY = "saas-header";
    // const { initialiseSaasHeader, hasError } = useSaasHeader({
    //     title,
    //     selector: HEADER_ELEMENT_KEY,
    // });

    useEffect(() => {
        if (wayfarerMode) {
            // Insert the necessary scripts
            const script = document.createElement("script");
            script.setAttribute("type", "text/javascript");
            script.setAttribute("src", `${SAAS_ASSETS_URL}/common-components/experian-saas-header.js`);
            document.head.appendChild(script);

            // Load the webcomponents-bundle.js script
            const webComponentsScript = document.createElement("script");
            webComponentsScript.setAttribute("src", "/Scripts/js/webcomponents-bundle.js");
            document.head.appendChild(webComponentsScript);

            // Function to initialize SaasHeader
            const initializeHeader = () => {
                const SaasHeader = window.ExperianSaaSComponent.SaasHeader;

                if (SaasHeader) {
                    // ***************************************************************************************************8
                    // ***** To add function, we need to add software-lib-ui-core
                    // https://pages.experian.local/display/AOP/Header+Usage
                    // https://code.experian.local/projects/DASA/repos/software-lib-ui-core/browse/src/utils/window.ts#91
                    //const navResourceCenter = () => dispatch(openTabToUrl("/wiki/"));

                    // addFunctionsToWindow({
                    //     navResourceCenter: navResourceCenter,
                    //     navDocumentation: navDocumentation,
                    //     selectCompany: selectCompany,
                    // });

                    //new SaasHeader({ title: title, selector: HEADER_ELEMENT_KEY, navContent: navContent, utilities: utilities });
                    /* eslint-disable no-new */
                    new SaasHeader({ title, selector: HEADER_ELEMENT_KEY });
                    /* eslint-enable no-new */

                    // handlePubSubHelp();
                    // ***************************************************************************************************8
                    // ***** Can we need to remove this? This is failing
                    // Call any initialization method if needed
                    // saasHeaderInstance.initialize();
                }
            };

            // Prepare the SaasHeader class to be called and subsequently initialize the header
            window.addEventListener("SaasHeaderReady", initializeHeader);

            return () => {
                // Cleanup the appended elements when the component unmounts
                document.head.removeChild(script);
                document.head.removeChild(webComponentsScript);
                window.removeEventListener("SaasHeaderReady", initializeHeader);
            };
        }
    }, [wayfarerMode]);

    return <>{wayfarerMode && <div id="saas-header"></div>}</>;
};

SaasHeader.propTypes = {};

export default SaasHeader;
